// @ts-nocheck
import React from 'react';
import { Navigate } from 'react-router-dom';
import { navPermissionCheck } from './authUtils';
import Loading from '../common/Loading';
import { useAppSelector } from '../../hooks';

function PrivateRoute({
  allowedPermissions,
  allowedUserTypes,
  isPowerUser,
  children,
}) {
  const currentUser = useAppSelector((state) => state.auth);

  if (currentUser == null) {
    return <Loading message="logging in..." />;
  }

  if (currentUser?.isLoading) {
    return <Loading message="Please wait.." />;
  }

  // if this route has permissions, check agains the user
  let hasPermission = navPermissionCheck(
    currentUser,
    allowedPermissions,
    allowedUserTypes,
    isPowerUser
  );

  if (!hasPermission) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
}



export default PrivateRoute;
